/* eslint-disable @typescript-eslint/no-unsafe-return */
import * as sourceOfTruth from 'helpers/languages/en.json';
import { ReactNode } from 'react';
import { PrimitiveType, useIntl } from 'react-intl';

export type LocaleMessages = typeof sourceOfTruth;
export type LocaleKey = string;

export type SupportedLocales = 'en' | 'fr';

const TRANSLATIO_URL = process.env.REACT_APP_TRANSLATIO_URL as string;

export const importMessages = (locale: SupportedLocales): Promise<LocaleMessages> => {
    let url: string;
    switch (locale) {
        case 'en':
            url = `${TRANSLATIO_URL}/cdm-translations-en.json`;
            break;
        case 'fr':
            url = `${TRANSLATIO_URL}/cdm-translations-fr.json`;
            break;
        default:
            url = `${TRANSLATIO_URL}/cdm-translations-en.json`;
            break;
    }

    return fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw new Error('server error');
            }
            return response.json();
        })
        .catch(() => {
            switch (locale) {
                case 'en':
                    return import(`./en.json`);
                case 'fr':
                    return import(`./fr.json`);
                default:
                    return import(`./en.json`);
            }
        });
};

export const useTranslation = () => {
    const intl = useIntl();
    const translate: (id: LocaleKey, values?: Record<string, PrimitiveType | ReactNode>) => string | ReactNode = (
        id,
        values?,
    ) => {
        return intl.formatMessage({ id, defaultMessage: id }, values);
    };

    return translate;
};
